import type { ReploSymbol } from "schemas/generated/symbol";

type BuiltInSymbolType = "collapsible";

export const builtInSymbolDirectory: Record<BuiltInSymbolType, ReploSymbol> = {
  collapsible: {
    id: "alchemy:collapsible",
    name: "Collapsible",
    storeId: "",
    component: {
      type: "collapsible",
      id: "alchemy:collapsible",
      props: {},
    },
    variants: [
      {
        id: "alchemy:collapsibleClosed",
        name: "default",
        query: null,
        componentOverrides: null,
      },
      {
        id: "alchemy:collapsibleOpen",
        name: "Open",
        query: null,
        componentOverrides: null,
      },
    ],
  },
};

export function hasBuiltInSymbol(type: string): type is BuiltInSymbolType {
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return builtInSymbolDirectory[type as BuiltInSymbolType] !== undefined;
}

export function getBuiltInSymbol(type: string) {
  return type in builtInSymbolDirectory
    ? // Legacy cast - may or may not be necessary
      // eslint-disable-next-line replo/no-as-cast
      builtInSymbolDirectory[type as BuiltInSymbolType]
    : null;
}
